import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { extendedTestimonials, stats, testimonials } from '../data/testimonials';
function Stars() {
  return <div className="flex gap-1 text-highlight" role="img" aria-label="5 de 5 estrellas" data-id="element-188" data-mp="3gqhrf93fin4g">
      {[1, 2, 3, 4, 5].map(item => <StarIcon key={item} className="h-4 w-4 fill-current" aria-hidden="true" data-id="element-189" data-mp="3brdjels8qvfp" />)}
    </div>;
}
function initials(name: string) {
  return name.split(' ').map(part => part[0]).join('').replace('.', '');
}
export function StatsAndProof() {
  return <>
      <section className="border-y border-primary/20 bg-canvas px-4 py-14 sm:py-20" data-id="element-190" data-mp="3lo05tf07tuju">
        <div className="mx-auto grid max-w-3xl grid-cols-3 gap-x-5 gap-y-10" data-id="element-191" data-mp="3b23j1fyapmi">
          {stats.map(([value, label]) => <div key={label} className="text-center" data-id="element-192" data-mp="3vhqou4dkpcs5">
              <p className="font-display text-4xl font-bold sm:text-6xl" data-id="element-193" data-mp="db2lok232zp4">
                {value}
              </p>
              <p className="mt-2 text-xs font-semibold leading-tight text-primary-soft sm:text-sm" data-id="element-194" data-mp="8chlgkmu0g0o">
                {label}
              </p>
            </div>)}
        </div>
      </section>
      <section className="bg-surface px-4 py-16 sm:py-20" aria-label="Testimonios" data-id="element-195" data-mp="1lcqxi7f6zv5y">
        <div className="mx-auto max-w-6xl" data-id="element-196" data-mp="1qaspxiyid6u3">
          <div className="grid gap-5 md:grid-cols-3" data-id="element-197" data-mp="1qd56pssj5b5k">
            {testimonials.map(({
            name,
            place,
            quote
          }, index) => <motion.article key={name} initial={{
            opacity: 0,
            y: 15
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.06
          }} className="flex h-full flex-col rounded-2xl border border-foreground/10 bg-canvas p-6" data-id="element-198" data-mp="1zcihqpway7se" data-mpi={index}>
                <div className="flex items-center gap-3" data-id="element-199" data-mp="2i2i3p3wuj6rl">
                  <div className="grid h-11 w-11 shrink-0 place-items-center rounded-full border border-primary/40 font-bold text-primary-soft" data-id="element-200" data-mp="2i41kqwqbtluf">
                    {initials(name)}
                  </div>
                  <div data-id="element-201" data-mp="mzbmo2cm9k09">
                    <h3 className="font-bold" data-id="element-202" data-mp="ixgoh6pzfmqp">{name}</h3>
                    <p className="text-sm text-foreground-subtle" data-id="element-203" data-mp="iz1imv8dx3o1">{place}</p>
                  </div>
                </div>
                <div className="mt-5" data-id="element-204" data-mp="wqy5okv74ndk">
                  <Stars data-id="element-205" data-mp="rxmvc9r6dogw" />
                </div>
                <p className="mt-4 italic leading-relaxed text-foreground-muted" data-id="element-206" data-mp="rwtxjya729aw">
                  “{quote}”
                </p>
              </motion.article>)}
          </div>
        </div>
      </section>
    </>;
}
export function ExtendedTestimonials() {
  return <section className="border-y border-foreground/10 bg-surface px-4 py-14 sm:py-20" data-id="element-207" data-mp="1fnzd0cc82zko">
      <div className="mx-auto max-w-5xl" data-id="element-208" data-mp="1ao4nac46og17">
        <h2 className="mb-10 text-center font-display text-2xl font-bold text-primary-soft sm:text-3xl" data-id="element-209" data-mp="1ap5xkeddkyhv">
          EXPERIENCIAS DE NUESTROS CLIENTES 💬
        </h2>
        <div className="grid gap-7 md:grid-cols-2" data-id="element-210" data-mp="3cgst8t87phko">
          {extendedTestimonials.map(({
          name,
          place,
          quote
        }) => <article key={name} className="border-l-2 border-primary pl-4" data-id="element-211" data-mp="1ryqm6qb0mst4">
              <div className="flex items-center gap-3" data-id="element-212" data-mp="1wvqkug5jcta7">
                <div className="grid h-9 w-9 shrink-0 place-items-center rounded-full border border-primary/40 text-sm font-bold text-primary-soft" data-id="element-213" data-mp="1j5wt9q2nbuws">
                  {initials(name)}
                </div>
                <p className="font-bold" data-id="element-214" data-mp="196xvj2jf5jok">
                  {name}{' '}
                  <span className="font-normal text-foreground-subtle" data-id="element-215" data-mp="199tsanjj62bf">· {place}</span>
                </p>
              </div>
              <div className="mt-2" data-id="element-216" data-mp="107askcb1k5te">
                <Stars data-id="element-217" data-mp="1083zpedwwxc2" />
              </div>
              <p className="mt-2 text-sm italic leading-relaxed text-foreground-muted" data-id="element-218" data-mp="148e9l24ts7w7">
                “{quote}”
              </p>
            </article>)}
        </div>
      </div>
    </section>;
}